"use client";

import { c as _c } from "react/compiler-runtime";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { AccordionContent, AccordionItem, Accordion as BaseAccordion, cn } from "@saridana-core/react-ui-kit";
import { TAccordion } from "@shared/types";
import { HtmlParser } from "../html-parser";
function AccordionTriggerCustom(t0) {
  const $ = _c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("group flex flex-1 items-center text-left justify-between gap-6 py-8 font-semibold transition-all w-full text-xl md:text-2xl", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={cn("size-8 min-w-8 transition-all duration-300 rounded-full inline-flex items-center justify-center text-center bg-gray-100", "group-data-[state=open]:bg-primary", "group-data-[state=open]:text-white")}><MinusIcon className="size-5 hidden group-data-[state=open]:inline-block" /><PlusIcon className="size-5 group-data-[state=open]:hidden" /></div>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== t1) {
    t3 = <AccordionPrimitive.Trigger className={t1} {...props}>{children}{t2}</AccordionPrimitive.Trigger>;
    $[7] = children;
    $[8] = props;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export function Accordion(t0) {
  const $ = _c(5);
  const {
    accordions
  } = t0;
  const t1 = "accordion-" + accordions[0]?.id;
  let t2;
  if ($[0] !== accordions) {
    t2 = accordions.map(_temp);
    $[0] = accordions;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <BaseAccordion type="single" collapsible={true} className="w-full -mt-7" defaultValue={t1}>{t2}</BaseAccordion>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(accordion) {
  return <AccordionItem key={"accordion-" + accordion.id} value={"accordion-" + accordion.id} className="border-b border-b-gray-200 data-[state=open]:border-b-primary-600 data-[state=open]:border-b-2"><AccordionTriggerCustom className="text-xl sm:text-2xl leading-[140%]">{accordion.attributes?.title}</AccordionTriggerCustom><AccordionContent className="pb-8 text-lg sm:text-xl text-grey-700 leading-[140%]"><HtmlParser data={accordion?.attributes?.description} /></AccordionContent></AccordionItem>;
}